import { memo, useContext } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Brain } from 'lucide-react'
import { ExecutionContext } from '../../../components/flow-nodes/shared/ExecutionContext'

// Handle 样式常量
const HANDLE_STYLE = {
  width: 12,
  height: 12,
  background: '#94a3b8',
  border: '2px solid white',
} as const

const HANDLE_STYLE_ACTIVE = {
  ...HANDLE_STYLE,
  background: '#8b5cf6',
} as const

// v16.0: HermesAgent — skill-driven native agent, no config panel needed
export const HermesAgentNode = memo(({ data, selected, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-purple-50 border-2 min-w-[180px] transition-all duration-300 ${
      isActive 
        ? 'border-purple-500 ring-4 ring-purple-400/50 shadow-xl scale-105 animate-pulse' 
        : selected 
          ? 'border-purple-500 ring-2 ring-purple-500/20 shadow-xl' 
          : isVisited 
            ? 'border-purple-300 ring-2 ring-purple-200/50' 
            : 'border-purple-200'
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        style={selected || isActive ? { ...HANDLE_STYLE_ACTIVE, background: '#8b5cf6' } : { ...HANDLE_STYLE, background: '#8b5cf6' }}
      />
      
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded-md transition-colors duration-300 ${isActive ? 'bg-purple-500' : 'bg-purple-100'}`}>
          <Brain className={`h-4 w-4 ${isActive ? 'text-white' : 'text-purple-600'}`} />
        </div>
        <div>
          <div className="font-medium text-sm text-purple-900">{data.label}</div>
          <div className="text-xs text-purple-600 flex items-center gap-1">
            <span>🧠</span>
            <span>Skill-driven</span>
          </div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={selected || isActive ? { ...HANDLE_STYLE_ACTIVE, background: '#8b5cf6' } : { ...HANDLE_STYLE, background: '#8b5cf6' }}
      />
    </div>
  )
})

HermesAgentNode.displayName = 'HermesAgentNode'
